// @flow
import React from 'react';
import { STRONG_PARAMETERS, WEIGHT_UNITS } from './weight-and-balance.consts';
import {
  DECIMAL_NEGATIVE_PATTERN,
  DECIMAL_NEGATIVE_PATTERN_EXTENDED,
  DECIMAL_PATTERN_EXTENDED_MAX
} from '../../utils/validation';
import type { Field, WeightUnit } from './weight-and-balance.types';
import {formatNumber} from './weight-and-balance.helpers';

type Props = {|
  onChange: (index: number, value: string) => void,
  onChangeFuelLoadType: (unit: WeightUnit) => void,
  fields: Field[],
  unit: WeightUnit,
|};

class WeightAndBalanceTable extends React.Component<Props, State> {

  handleChange = (index) => {
    return event => {
      const {onChange} = this.props;

      onChange(index, event.currentTarget.value);
    };
  }

  handleChangeFuelLoadType = (event) => {
    const {onChangeFuelLoadType} = this.props;

    onChangeFuelLoadType(event.target.value);
  }

  handleFocus = (weight, index) => () => {
    const { onChange } = this.props;

    if (!parseFloat(weight, 10)) {
      onChange(index, '');
    }
  };

  generateStatusIcon = (status) => {
    if (!status) {
      return;
    }
    if (status.length === 0) {
      return (<span className="weight-balance-status-icon icon checkmark-circle text-success"/>);
    } else {
      return (<span className="weight-balance-status-icon icon cancel-circled text-danger"/>);
    }
  }

  render() {
    const { unit, fields, onCalculate, status} = this.props;
    const showCGValues = localStorage.getItem('showCGValues') === 'true';

    return (
      <div>
        <table className='passengers-table'>
          <thead className='passengers-table-header'>
          <tr>
            <th></th>
            <th colSpan={status ? 1 : 2}>
              <span>Weight </span>
              <span className={"normal-weight"}> (lbs)</span>
            </th>
            <th>
              <span>Arm</span>
              <span className={"normal-weight"}> (in)</span>
            </th>
            <th>
              <span>Moment</span>
              <span className={"normal-weight"}> (lbs x in)</span>
            </th>
            {showCGValues && (
              <React.Fragment>
                <th className="normal-weight" children={'Fwd CG'}/>
                <th className="normal-weight" children={'Aft CG'}/>
              </React.Fragment>
            )}
          </tr>
          </thead>
          <tbody>
          {fields.map((field, index) => {
            const {
              weight: {value, editable, select},
              envelop = {},
              arm,
              moment,
              name,
              title,
              status: fieldStatus,
              isTime
            } = field;

            const { afterCg, forwardCg, cg } = envelop;
            const weight = value;
            const className = STRONG_PARAMETERS.includes(title) ? 'text-bold' : '';
            let pattern = select ? DECIMAL_NEGATIVE_PATTERN_EXTENDED : DECIMAL_NEGATIVE_PATTERN;

            if (isTime) {
              pattern = DECIMAL_PATTERN_EXTENDED_MAX;
            }

            return (
              <tr key={`${name}-${index}`} className={className}>
                <td className='relative'>
                  {this.generateStatusIcon(fieldStatus)}
                  {title}
                </td>
                <td>
                  {editable && (
                    <div className='passengers-table-input-wrapper'>
                      <input
                        className='form-control'
                        size='8'
                        type='text'
                        data-index={index}
                        pattern={pattern}
                        value={value}
                        onChange={this.handleChange(index)}
                        onFocus={this.handleFocus(value, index)}
                      />
                      {select && (
                        <select onChange={this.handleChangeFuelLoadType} className='form-control passengers-table-select' value={unit}>
                          <option value={WEIGHT_UNITS.percent}>{WEIGHT_UNITS.percent}</option>
                          <option value={WEIGHT_UNITS.lbs}>{WEIGHT_UNITS.lbs}</option>
                          <option value={WEIGHT_UNITS.kg}>{WEIGHT_UNITS.kg}</option>
                          <option value={WEIGHT_UNITS.gal}>{WEIGHT_UNITS.gal}</option>
                          <option value={WEIGHT_UNITS.liters}>{WEIGHT_UNITS.liters}</option>
                        </select>
                      )}
                    </div>
                  )}

                  {!editable && !select && (
                    formatNumber(weight)
                  )}

                </td>
                <td>{!select && formatNumber(arm)}</td>
                <td>{!select && formatNumber(moment)}</td>
                {showCGValues && envelop && !select && (
                  <React.Fragment>
                    <td children={formatNumber(forwardCg)}/>
                    <td children={formatNumber(afterCg)}/>
                  </React.Fragment>
                )}
              </tr>
            );
          })}
          <tr>
            <td colSpan={4}>
              <button onClick={onCalculate} type='button' className='btn btn-info btn-block'>Recalculate</button>
            </td>
          </tr>
          </tbody>
        </table>
        <ul className="weight-balance-status-list">
          {status.map((item, index) => {
            if (item.success) {
              return (
                <li key={`message-${index}`} className="relative weight-balance-status">
                  <span className="weight-balance-status-icon icon checkmark-circle text-success"></span>
                  <span className="text-success">{item.message}</span>
                </li>
              );
            } else {
              return (
                <li key={`message-${index}`} className="relative weight-balance-status">
                  <span className="weight-balance-status-icon icon cancel-circled text-danger"></span>
                  <span className="text-danger">{item.message}</span>
                </li>
              );
            }
          })}
        </ul>
      </div>
    );
  }
}

export default WeightAndBalanceTable;
